import cloneDeep from 'lodash/cloneDeep';
import buildMultiAxisTooltip from './multiAxis';
import buildPieTooltip from './pie';
import buildBoxPlotTooltip from './boxplot';
import buildPackedBubbleTooltip from './packedbubble';
import buildGaugeTooltip from './gauge';
import buildFunnelTooltip from './funnelchart';
import buildSankeyTooltip from './sankey';
import buildBulletTooltip from './bullet';
import buildPyramidTooltip from './pyramid';
import buildHeatmapTooltip from './heatmap';
import buildTreemapTooltip from './treemap';
import { buildTooltipText } from '../../../utils/tooltip';
import chartUtils from '../../../utils/chart-utils';

var TOOLTIP_BASE = {
    followTouchMove: false,
    snap: 0,
    useHTML: true,
    style: {
        pointerEvents: 'auto'
    },
    fontSize: '20px'
};

var configureTooltip = function configureTooltip(seriesType, seriesConfig) {
    var config = cloneDeep(TOOLTIP_BASE);
    var defaultTipText = void 0,
        defaultValue = void 0;

    return {
        pointFormatter: function pointFormatter() {
            switch (seriesType.toLowerCase()) {
                case 'pie':
                case 'doughnut':
                    defaultTipText = buildPieTooltip(seriesConfig, this);
                    defaultValue = seriesConfig.ValueField;
                    break;
                case 'bar':
                case 'column':
                case 'area':
                case 'line':
                case 'spline':
                case 'waterfall':
                case 'bubble':
                case 'polygon':
                case 'scatter':
                    defaultTipText = buildMultiAxisTooltip(seriesConfig, this);
                    defaultValue = seriesConfig.FieldName;
                    break;
                case 'boxplot':
                    defaultTipText = buildBoxPlotTooltip(seriesConfig, this);
                    defaultValue = seriesConfig.FieldName;
                    break;
                case 'packedbubble':
                    defaultTipText = buildPackedBubbleTooltip(seriesConfig, this);
                    defaultValue = seriesConfig.AreaValueField;
                    break;
                case 'gauge':
                    defaultTipText = buildGaugeTooltip(seriesConfig, this, seriesConfig.ValueField);
                    defaultValue = seriesConfig.ValueField;
                    break;
                case 'gauge_targetline':
                    defaultTipText = buildGaugeTooltip(seriesConfig, this, seriesConfig.TargetField);
                    defaultValue = seriesConfig.TargetField;
                    break;
                case 'funnelchart':
                    defaultTipText = buildFunnelTooltip(seriesConfig, this);
                    defaultValue = seriesConfig.ValueField;
                    break;
                case 'bullet':
                    defaultTipText = buildBulletTooltip(seriesConfig, this);
                    defaultValue = seriesConfig.ActualValue;
                    break;
                case 'sankey':
                    defaultTipText = buildSankeyTooltip(seriesConfig, this);
                    defaultValue = seriesConfig.ValueFieldName;
                    break;
                case 'pyramidchart':
                    defaultTipText = buildPyramidTooltip(seriesConfig, this);
                    defaultValue = seriesConfig.ValueField;
                    break;
                case 'heatmap':
                    defaultTipText = buildHeatmapTooltip(seriesConfig, this);
                    defaultValue = seriesConfig.ValueField;
                    break;
                case 'treemap':
                    defaultTipText = buildTreemapTooltip(seriesConfig, this);
                    defaultValue = seriesConfig.ValueFieldName;
                    break;

            }
            return buildTooltipText(seriesConfig.Tooltip, this.options, defaultTipText, defaultValue, seriesConfig.AggregationType, seriesConfig.TotalRecords);
        },
        headerFormat: '',
        nodeFormatter: function nodeFormatter() {
            var defaultNodeTipText = '<span class="tip-header">' + this.name + '</span>' + ': <span class="tip-value">' + chartUtils.format(this.sum, seriesConfig.ValueFormat, seriesConfig.CurrencySymbol, null, seriesConfig.BaseFormat) + '</span>';

            return defaultNodeTipText;
        }
    };
};
export default configureTooltip;